import type { FC } from 'react'

import { SwitchCamera } from '@liveHelper/assets/SwitchCamera'
import { ActionButton } from '@oneToOne/shared/styles'

import { deviceSettingsActionsSelector } from '@core/deviceSettings'
import { useGlobalStore } from '@core/hooks/useGlobalStore'
import { useContextTranslation } from '@core/i18n'

interface SwitchCameraButtonProps {
  isMinimized?: boolean
}

/**
 * Button to swap between front and back camera.
 * This will only be rendered for users on a mobile device
 */
export const SwitchCameraButton: FC<SwitchCameraButtonProps> = ({
  isMinimized,
}) => {
  const { t } = useContextTranslation()
  const { toggleFacingMode } = useGlobalStore(deviceSettingsActionsSelector)

  return (
    <ActionButton
      aria-label={t(`oneToOne:Switch Camera`)}
      actionType="neutral"
      buttonSize={isMinimized ? 'md' : 'lg'}
      shape="circle"
      onClick={toggleFacingMode}
      icon={
        <SwitchCamera
          width={isMinimized ? '18px' : '26px'}
          fill="var(--white)"
          label="camera"
        />
      }
    />
  )
}
